// initial state
const state = {
    pages: []
}

// getters
const getters = {
    page: state => slug => state.pages.find(p => p.fields.slug === slug),
    pages: state => state.pages.sort((a, b) => {
        return a.fields.menuOrder - b.fields.menuOrder;
    })
}

// actions
const actions = {
    addPage({ commit }, page) {
        commit('ADD_PAGE', page);
    }
}

// mutations
const mutations = {
    ADD_PAGE(state, page) {
        state.pages.push(page);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/pages.js